module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Strike-Back-S7.9c539bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Strike-Back-S7.jpg
// module id = Aqw9
// module chunks = 0